<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="自动财审客户" v-if="findChildren(65)!==-1" name="collectioncustomer" style="height: 100%;">
				<collectioncustomer-index />
			</el-tab-pane>
			<el-tab-pane label="开票客户" v-if="findChildren(67)!==-1" name="invoicecustomer" style="height: 100%;">
				<invoicecustomer-index />
			</el-tab-pane>
		</el-tabs>
A

	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import collectioncustomerIndex from './collectioncustomer/index.vue'
	import invoicecustomerIndex from './invoicecustomer/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if(this.departmentChildren.length!=0){
				this.activeName = this.departmentChildren[0].controller
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			collectioncustomerIndex,
			invoicecustomerIndex

		}
	}
</script>
